import React from "react";
import { motion } from "motion/react";
import { FaApple, FaGooglePlay, FaGithub, FaArrowRight, FaLayerGroup, FaGlobe } from "react-icons/fa";
import { PhoneMockup, BrowserMockup, TerminalMockup, CodePackageMockup } from "../DeviceMockup";

const ProjectCard = ({ project, onSelectProject }) => {
  return (
    <motion.div
      className="mobbin-project-card"
      initial={{ opacity: 0, y: 15 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.05 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      whileHover={{ y: -4, transition: { duration: 0.2 } }}
    >
      {/* Card Visual Preview (Interactive Frame) */}
      <div
        className="card-preview-viewport"
        style={{ background: project.gradient }}
        onClick={() => onSelectProject(project)}
      >
        <div className={`preview-scale-box ${project.mockupType}`}>
          {project.mockupType === "phone" && <PhoneMockup project={project} />}
          {project.mockupType === "browser" && <BrowserMockup project={project} />}
          {project.mockupType === "terminal" && <TerminalMockup project={project} />}
          {project.mockupType === "code" && <CodePackageMockup project={project} />}
        </div>
        <div className="preview-hover-overlay">
          <span className="hover-inspect-pill">
            <FaLayerGroup /> Click to Inspect Architecture & Details
          </span>
        </div>
      </div>

      {/* Card Content & Details */}
      <div className="card-info-pane">
        <div className="card-header-row">
          <span
            className="card-cat-badge"
            style={{
              color: project.color,
              borderColor: `${project.color}45`,
              backgroundColor: `${project.color}15`,
            }}
          >
            {project.categoryLabel}
          </span>
          <span className="card-platform-pill">{project.platform}</span>
        </div>

        <h3 className="card-project-title" onClick={() => onSelectProject(project)}>
          {project.title}
        </h3>
        <p className="card-project-subtitle">{project.subtitle}</p>
        <p className="card-project-desc">{project.shortDesc}</p>

        {/* Tech Stack Chips */}
        <div className="card-tech-chips">
          {project.tags.slice(0, 4).map((tag, i) => (
            <span key={i} className="mini-tag-chip">
              {tag}
            </span>
          ))}
          {project.tags.length > 4 && (
            <span className="mini-tag-chip more-chip">
              +{project.tags.length - 4}
            </span>
          )}
        </div>

        {/* Card Actions / Store Links */}
        <div className="card-footer-actions">
          <div className="store-links-group">
            {project.links.appStore && (
              <a
                href={project.links.appStore}
                target="_blank"
                rel="noopener noreferrer"
                className="mini-store-btn ios"
                title="View on Apple App Store"
              >
                <FaApple /> <span>App Store</span>
              </a>
            )}

            {project.links.playStore && (
              <a
                href={project.links.playStore}
                target="_blank"
                rel="noopener noreferrer"
                className="mini-store-btn android"
                title="View on Google Play Store"
              >
                <FaGooglePlay /> <span>Play Store</span>
              </a>
            )}

            {project.links.web && (
              <a
                href={project.links.web}
                target="_blank"
                rel="noopener noreferrer"
                className="mini-store-btn web"
                title="View Live Web App"
              >
                <FaGlobe /> <span>Website</span>
              </a>
            )}

            {project.links.github && (
              <a
                href={project.links.github}
                target="_blank"
                rel="noopener noreferrer"
                className="mini-store-btn github"
                title="View GitHub Repository"
              >
                <FaGithub /> <span>Code</span>
              </a>
            )}
          </div>

          <button
            className="details-trigger-btn"
            onClick={() => onSelectProject(project)}
          >
            <span>Details</span> <FaArrowRight />
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectCard;
